


















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DeviceVersionRule, JSONRule, SchemaField } from '@/types';
import { Action, Getter } from 'vuex-class';

@Component({
  components: {},
})
export default class RuleInput extends Vue {
  @Prop() private fields!: any[];
  @Prop({ default: () => ({})}) private value!: any;
  @Prop({ default: false }) private updateValidation!: boolean;

  private currentValue: JSONRule = {
    fact: '',
    path: '',
    operation: '',
    value: null,
  };

  private operators: Array<{icon: string, text: string, value: string}> = [
    { icon: 'mdi-equal', text: '=', value: 'equals' },
    { icon: 'mdi-less-than', text: '<', value: 'lessThan' },
    { icon: 'mdi-greater-than', text: '>', value: 'greaterThan' },
    { icon: 'mdi-less-than-or-equal', text: '≤', value: 'lessThanInclusive' },
    { icon: 'mdi-greater-than-or-equal', text: '≥', value: 'greaterThanInclusive' },
  ];

  @Watch('updateValidation')
  private validateOnChange(value: number) {
    this.validate();
  }

  private validate() {
    if (!(this.$refs.fields as Vue & { validate: () => boolean }).validate() ||
      !(this.$refs.ops as Vue & { validate: () => boolean }).validate() ||
      !(this.$refs.val as Vue & { validate: () => boolean }).validate()) {
      this.$emit('preventSave', true);
    } else {
      this.$emit('preventSave', false);
    }
  }

  @Watch('value', {immediate: true})
  private onValueChange() {
    if (this.value) {
      Vue.set(this, 'currentValue', this.value);
    }
  }

  private get pathModel() {
    return this.currentValue.path;
  }

  private set pathModel(value: string) {
    this.currentValue.path = value;
    this.$emit('inputChanged', this.currentValue);
  }

  private get operationModel() {
    return this.currentValue.operation;
  }

  private set operationModel(value: string) {
    this.currentValue.operation = value;
    this.$emit('inputChanged', this.currentValue);
  }

  private get valueModel() {
    return this.currentValue.value;
  }

  private set valueModel(value: string) {
    this.currentValue.value = value;
    this.$emit('inputChanged', this.currentValue);
  }

}
